import React from 'react';
import {connect} from 'react-redux';

import {useTranslation} from 'react-i18next';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import * as AdminLte from 'admin-lte';
import * as $ from 'jquery';



const MenuSidebar = ({user,company}) => {
    const {t} = useTranslation();
    $('[data-widget="treeview"]').each(function() {
        AdminLte.Treeview._jQueryInterface.call($(this), 'init');
        AdminLte.Layout._jQueryInterface.call($('body'));
        AdminLte.PushMenu._jQueryInterface.call($('[data-widget="treeview"]'));            
       // AdminLte.PushMenu._jQueryInterface.call($('[data-widget="pushmenu"]'));
    });


    let companyName = '';
    
    try{
         companyName = company && company.address ? company.address.name : '';
    }catch(error){
        console.log(error);
    }

   
 
        return (
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                <Link to="/" className="brand-link">
                    <img
                        src={require('../../../img/logo.png')}                    
                        className="brand-image img-thumbnail elevation-3 "                       
                        style={{opacity: '.8'}}
                        alt="Logo"
                    />
                    <span className="brand-text font-weight-light">{companyName}</span>
                </Link>
                <div className="sidebar" style={{ paddingLeft: '0' }}>          
                    <nav className="mt-2" style={{ paddingLeft: '0' }}>
                        <ul
                            className="nav nav-pills nav-sidebar flex-column"
                            data-widget="treeview"
                            role="menu"
                            data-accordion="false"
                        >
                            <li className="nav-item">
                                <NavLink to='/' tag={Link} >
                                    <i className="nav-icon fas fa-tachometer-alt" />
                                    <p>{t('menusidebar.label.dashboard')}</p>
                                </NavLink>
                            </li>
                            <li className="nav-item has-treeview">
                               <NavLink to='#'>
                                    <i className="nav-icon fas fa-university" />
                                    <p>{t('menusidebar.label.company')}
                                    <i className="right fas fa-angle-left" /></p>
                                </NavLink>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <NavLink to="/basicData" tag={Link}>                                  
                                            <i className="nav-icon fas fa-info-circle"></i>
                                            <p>{t('menusidebar.label.basicData')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/code" tag={Link}>                                  
                                            <i className="nav-icon fa fa-list"></i>
                                            <p>{t('general.label.codeList')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/user"  tag={Link}>                                  
                                            <i className="nav-icon far fa-address-card"></i>
                                            <p>{t('menusidebar.label.users')}</p>                             
                                        </NavLink>
                                    </li>
                               </ul>
                            </li>

                            <li className="nav-item has-treeview">
                            <NavLink to='#'>
                                    <i className="nav-icon fa fa-users" />
                                    <p>{t('menusidebar.label.team')}
                                    <i className="right fas fa-angle-left" /></p>
                                </NavLink>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <NavLink to="/attendance"  tag={Link}>                                  
                                            <i className="nav-icon fa fa-clock"></i>
                                            <p>{t('menusidebar.label.attendance')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/tasks"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-tasks"></i>
                                            <p>{t('menusidebar.label.tasks')}</p>                             
                                        </NavLink>
                                    </li>
                               </ul>
                            </li>                           
                            <li className="nav-item has-treeview">
                            <NavLink to='#'>
                            <i className="nav-icon fa fa-handshake" />
                                    <p>{t('menusidebar.label.partners')}
                                    <i className="right fas fa-angle-left" /></p>
                                </NavLink>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <NavLink to="/customers"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-crown"></i>
                                            <p>{t('menusidebar.label.customers')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/suppliers"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-dolly"></i>
                                            <p>{t('menusidebar.label.suppliers')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/anotherPartners"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-building"></i>
                                            <p>{t('menusidebar.label.anotherPartners')}</p>                             
                                        </NavLink>
                                    </li>
                               </ul>
                            </li>

                            <li className="nav-item has-treeview">
                            <NavLink to='#'>
                            <i className="nav-icon far fa-newspaper" />
                                    <p>{t('article.label.articles')}
                                    <i className="right fas fa-angle-left" /></p>
                                </NavLink>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <NavLink to="/article"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-list"></i>
                                            <p>{t('article.label.article')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/warehouse"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-warehouse"></i>
                                            <p>{t('article.label.warehouse')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/warehouseOperations"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-dolly-flatbed"></i>
                                            <p>{t('article.label.warehouseOperations')}</p>                             
                                        </NavLink>
                                    </li>
                               </ul>
                            </li>


                            <li className="nav-item has-treeview">
                            <NavLink to='#'>
                            <i className="nav-icon fa fa-industry" />
                                    <p>{t('production.label.production')}
                                    <i className="right fas fa-angle-left" /></p>
                                </NavLink>
                                <ul 
                                className="nav nav-treeview">
                                    <li className="nav-item">
                                        <NavLink to="/operationsProcessing"  tag={Link}>                                  
                                            <i className="nav-icon fa fa-tasks"></i>
                                            <p>{t('workOrder.label.operationsProcessing')}</p>                             
                                        </NavLink>
                                    </li>                    
                                    <li className="nav-item">
                                        <NavLink to="/workOrder"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-sort-amount-down-alt"></i>
                                            <p>{t('production.label.workOrders')}</p>                             
                                        </NavLink>
                                    </li>                                    
                                    <li className="nav-item">
                                        <NavLink to="/wrRouteTemplate"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-sort-amount-down-alt"></i>
                                            <p>{t('workOrder.label.wrRouteTemplate')}</p>                             
                                        </NavLink>
                                    </li>   
                                    <li className="nav-item">
                                        <NavLink to="/bom"  tag={Link}>                                  
                                            <i className="nav-icon fa fa-sticky-note"></i>
                                            <p>{t('workOrder.label.bom')}</p>                             
                                        </NavLink>
                                    </li>   
                               </ul>
                            </li>



                            <li className="nav-item has-treeview">
                            <NavLink to='#'>
                            <i className="nav-icon fas fa-euro-sign" />
                                    <p>{t('menusidebar.label.invoicing')}
                                    <i className="right fas fa-angle-left" /></p>
                                </NavLink>
                                <ul className="nav nav-treeview">
                                    <li className="nav-item">
                                        <NavLink to="/orders"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-cart-arrow-down"></i>
                                            <p>{t('document.label.order')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/invoices"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-file-invoice"></i>
                                            <p>{t('document.label.invoice')}</p>                             
                                        </NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to="/deliveryNotes"  tag={Link}>                                  
                                            <i className="nav-icon fas fa-boxes"></i>
                                            <p>{t('document.label.deliveryNote')}</p>                             
                                        </NavLink>
                                    </li>
                               </ul>
                            </li>
                           
                            
                        </ul>
                    </nav>
                </div>
            </aside>
        );
    };
    
    const mapStateToProps = (state) => ({
        user: state.auth.currentUser,
        company: state.company.currentCompany
    });
    
    export default connect(mapStateToProps, null)(MenuSidebar);
    